import { Link, useLocation } from "react-router";
import { useAuth } from "../../hooks/useAuth";
import Button from "../Button";
import { ChevronRightIcon } from "@heroicons/react/24/outline";

export default function Header() {
  const { pathname } = useLocation();
  const { isAuthenticated } = useAuth();

  const isOnHome = pathname === "/";

  if (isAuthenticated && isOnHome) {
    return (
      <header className="flex flex-row justify-end items-center w-full">
        <Link to="/">
          <Button
            variant="primary"
            className="flex flex-row gap-2 items-center"
          >
            Mon espace
            <ChevronRightIcon className="w-4 h-4 mt-0.5" />
          </Button>
        </Link>
      </header>
    );
  }

  return (
    <header className="flex flex-row justify-between items-center w-full">
      <div className="flex flex-row gap-4 justify-end items-center w-full">
        <Link to="/signin">
          <Button variant="primary">Se connecter</Button>
        </Link>
        <Link to="/signup">
          <Button variant="secondary">S'inscrire</Button>
        </Link>
      </div>
    </header>
  );
}
